/**
 * Determines whether the `value` is an object literal.
 */
const isObject = value => {
  return typeof value === 'object' && (value === null || value === void 0 ? void 0 : value.constructor) === Object;
};

export { isObject as i };
